import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';

import {AuthService} from '../../services/auth.service';
import {EmailService} from '../../services/email.service';
import {LogService} from '../../services/log.service';
import {OrganizationService} from '../../services/organization.service';
import {PerfService} from '../../services/perf.service';
import {UserService} from '../../services/user.service';


@Component({
	selector: 'nonce',
	templateUrl: './nonce.component.html',
	styleUrls: ['./nonce.component.scss']
})
export class NonceComponent implements OnInit, AfterViewInit {
	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,

		private authService: AuthService,
		private emailService: EmailService,
		private log: LogService,
		private organizationService: OrganizationService,
		private perf: PerfService,
		private userService: UserService
	) { }


	userId = '';
	token = '';

	organization: any = {
		internalAbbreviatedName: '',
		domain: ''
	};
	contact: any = {
		firstName: '',
		lastName: '',
		email: ''
	};


	ngOnInit() {
		this.activatedRoute.params.subscribe((params: any) => {
			this.userId = params.userId;
			this.token = params.token;
		});

		try {
			if (localStorage) {
				this.log.visitUserId = this.userId;
				localStorage.setItem('u', this.log.visitUserId);
			}
		} catch (err) {
			console.log('NonceComponent ngOnInit, Error writing to local storage');
			console.log(err);
		}

		this.log.info(`Nonce start. userId=${this.userId} token=${this.token}`);

// TODO - add in clearCache
		// this.authService.clearCache();
		this.authService.authUsingNonce(this.userId, this.token).then(() => {
			this.log.info(`Nonce successful. userId=${this.userId}`);

			console.log('sending nonce successful email using AWS now.');



			// get the organization
			console.log('this.authService.organizationId = ' + this.authService.organizationId);
			this.organizationService.getOrganization(this.authService.organizationId)
				.then((organization: any) => {
					this.organization = organization.organization;
					console.log('this.organization');
					console.log(this.organization);



					// get the user
					this.userService.getUserProfile()
						.then((profile: any) => {
							this.contact = profile.profile;
							console.log('this.contact');
							console.log(this.contact);






							// let emailFrom = '"' + this.organization.internalAbbreviatedName + ' Team Manager" <teammanager.ptfilmfest@oceanbluffproductions.com>';
							let emailFrom = '"' + this.organization.internalAbbreviatedName + ' Team Manager" <teammanager.' + this.organization.domain + '@oceanbluffproductions.com>';
							let emailTo = '"' + this.contact.firstName + ' ' + this.contact.lastName + '" <' + this.contact.email + '>';

							// let emailFrom = '"Pat McFaul" <patmcfaul@gmail.com>';
							// let emailTo = '"Pat McFaul" <patmcfaul@itdevices.com>';
							// console.log('emailFrom = ' + emailFrom);
							// console.log('emailTo = ' + emailTo);

							let emailSubject = 'Reviewer Team Setup Complete';
							let emailBody = 'Congratulations ' + this.contact.firstName + '!\n\nYou have successfully setup your access to the reviewer software.  To access the site at any time, simply use this link:\n\n' + 'https://oceanbluffproductions.com' + '\n\nRemember, if you want to screen films on another device or browser, contact us for a second email invitation.\n\nGood luck on your films!\n\nThanks!\n\n';

							console.log('emailFrom = ' + emailFrom);
							console.log('emailTo = ' + emailTo);
							console.log('emailSubject = ' + emailSubject);
							console.log('emailBody = ' + emailBody);


							this.emailService.sendEmail2(emailFrom, emailTo, emailSubject, emailBody)
								.then(() => {

									console.log('nonce successful email sent.');
									// this.snackBar.open('Invite email sent!', 'X', {duration: 2000});

									// redirect
									this.router.navigate(['']);
								})
								.catch((err: any) => {
									// TODO - handle errors?
									this.log.error(err);
									// this.snackBar.open('Service not available now.', 'X', {duration: 2000});

									// redirect
									this.router.navigate(['']);
								});







						})
						.catch((err) => {			// this is a Response object, with res.status === 401, for example
		// !!! TODO - make sure should everywhere has catch, then fix everywhere!!!
							this.log.error(err);
							this.router.navigate(['']);
						});


				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
// !!! TODO - make sure should everywhere has catch, then fix everywhere!!!
					this.log.error(err);
					this.router.navigate(['']);
				});





			// // redirect
			// this.router.navigate(['']);
		}).catch((err) => {
			this.log.error(`Nonce failed. userId=${this.userId} token=${this.token}`);
			this.log.error(err);
			// redirect for now
			this.router.navigate(['']);
		});
	}


	ngAfterViewInit() {
		this.perf.markTabLoadEnd('nonce');
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/nonce/nonce.component.ts